// extracted by mini-css-extract-plugin
export default {"text":"Enroll_text__z38yC","button":"Enroll_button__Co+bN"};